var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDevicesfill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.5 4.5C2.94772 4.5 2.5 4.94772 2.5 5.5V19C2.5 19.5523 2.94772 20 3.5 20H6V4.5H3.5ZM20.15 4.5H18V20H20.15C20.8956 20 21.5 19.3956 21.5 18.65V5.85C21.5 5.10442 20.8956 4.5 20.15 4.5Z",
    fill: "currentcolor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 2C6.89543 2 6 2.89543 6 4V20C6 21.1046 6.89543 22 8 22H16C17.1046 22 18 21.1046 18 20V4C18 2.89543 17.1046 2 16 2H8ZM9.75 20.5C9.61193 20.5 9.5 20.6119 9.5 20.75C9.5 20.8881 9.61193 21 9.75 21H14.25C14.3881 21 14.5 20.8881 14.5 20.75C14.5 20.6119 14.3881 20.5 14.25 20.5H9.75Z",
    fill: "currentcolor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDevicesfill);
export default __webpack_public_path__ + "static/media/Devices fill.de30de2f037bd19cb3896c9fde703ceb.svg";
export { ForwardRef as ReactComponent };